import { render, staticRenderFns } from "./investContent.vue?vue&type=template&id=3ec908c2&"
import script from "./investContent.vue?vue&type=script&lang=js&"
export * from "./investContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports